import { render } from "./ad-post.vue?vue&type=template&id=74522cb6"
import script from "./ad-post.vue?vue&type=script&lang=js"
export * from "./ad-post.vue?vue&type=script&lang=js"

import "./ad-post.vue?vue&type=style&index=0&id=74522cb6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__